
import React, { useState } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    Menu,
    MenuItem,
    TextField
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {useTheme} from '@mui/material/styles';
import {LayoutModel} from '../../models/models';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

export const LayoutSelectorComponent: React.FC<{
  selectedLayout: LayoutModel | null,
  availableLayouts: LayoutModel[],
  selectLayout: (thisLayout: LayoutModel) =>  void
}> = ( {
  selectedLayout,
  availableLayouts,
  selectLayout
}) => {

  const styles = ContainerClasses();

  const [anchorElMenu, setAnchorElMenu] = React.useState<null | HTMLElement>(null);

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElMenu(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorElMenu(null);
  };


  const menuElement = (layout: LayoutModel) => {

    return (
      <MenuItem
         key={layout.Uuid_sys}
         onClick={() => {setAnchorElMenu(null);
                         selectLayout(layout);}}
      >
         <Typography
            sx={{ textAlign: 'center' }}
         >
           {layout.Label_sys}
         </Typography>
      </MenuItem>
    )
  }

  const ITEM_HEIGHT=48;


  return (
    <Box sx={styles.containerRowC}>
       <Typography variant="h6">
          Layout: {selectedLayout?.Label_sys}
       </Typography>

      <Box>
          <IconButton
            size="large"
            onClick={handleOpenMenu}
            color="inherit"
          >
            <ArrowDropDownIcon />
          </IconButton>

          <Menu
            id="menu-list"
            anchorEl={anchorElMenu}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            open={Boolean(anchorElMenu)}
            onClose={handleCloseMenu}
            sx={{ display: { xs: 'block' } }}
            slotProps = {{
              paper: {
                style: {
                  maxHeight: 4.5*ITEM_HEIGHT,
                }
              }
            }}
          >
             {availableLayouts.map((layout) => menuElement(layout))}
          </Menu>
      </Box>

</Box>
);
};
